<template>
    <div class="wp-content">
      <!-- Iterate through layouts in page -->
      <!-- Essentially each layout is a row -->
      <BaseLayout v-for="(layout, index) in layouts" :key="index" :layoutData="layout"/>
      <vue-headful :title="pageTitle" :description="pageDescription" :keywords="pageKeywords"/>
    </div>
</template>

<script>
import BaseLayout from "./layouts/BaseLayout";

export default {
  name: "WordpressDisplayContent",
  components: {
    BaseLayout
  },
  //page slug is the slug of the page to show, show loading is weather to show loading indicator
  props: ["pageData"],
  computed: {
    layouts() {
      if (!this.pageData) return [];

      return this.pageData.acf.layouts;
    },
    pageTitle() {
	if(this.$route.name=='signup') {
		return "Signup | Cherrytree";
	}
      if (
        this.pageData &&
        this.pageData.acf &&
        this.pageData.acf.title &&
        this.pageData.acf.title != ""
      ) {
        return this.pageData.acf.title;
      }
      return "Cherrytree";
    },
    pageDescription() {
      if (
        this.pageData &&
        this.pageData.acf &&
        this.pageData.acf.description &&
        this.pageData.acf.description != ""
      ) {
        return this.pageData.acf.description;
      }
      return "Cherrytree, the club for smart shoppers";
    },
    pageKeywords() {
      if (
        this.pageData &&
        this.pageData.acf &&
        this.pageData.acf.keywords &&
        this.pageData.acf.keywords != ""
      ) {
        return this.pageData.acf.keywords;
      }
      return "Cherrytree, wholesale, shopping, brands, discount";
    }
  }
};
</script>

<style lang="scss">
</style>
